import { Languages, Check } from "lucide-react";
import type { SettingsTabProps } from "./types";
import type { Language } from "../../types/translation";

interface LanguageTabProps extends SettingsTabProps {
  currentLanguage: Language;
  setLanguage: (language: Language) => void;
}

export default function LanguageTab({
  currentLanguage,
  setLanguage,
}: LanguageTabProps) {
  return (
    <div className="space-y-4">
      {/* Mobile-optimized header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          <Languages className="h-5 w-5 text-primary-600 dark:text-primary-400" />
        </div>
        <div>
          <h3 className="text-base font-semibold text-gray-900 dark:text-white">
            Language Settings
          </h3>
          <p className="text-xs text-gray-600 dark:text-dark-400">
            Choose your preferred language
          </p>
        </div>
      </div>

      <div className="space-y-3">
        <h4 className="text-sm font-medium text-gray-900 dark:text-white border-b border-gray-100 dark:border-dark-700 pb-2">
          Select Language
        </h4>

        <div className="space-y-3">
          <button
            onPointerDown={() => setLanguage("en")}
            className={`w-full flex items-center justify-between p-3 rounded-lg border transition-all duration-200 ${
              currentLanguage === "en"
                ? "border-primary-500 bg-primary-50 dark:bg-primary-900/30"
                : "border-gray-200 dark:border-dark-600 hover:border-gray-300 dark:hover:border-dark-500 bg-gray-50 dark:bg-dark-700 hover:bg-gray-100 dark:hover:bg-dark-600"
            }`}
            style={{ touchAction: "manipulation" }}
          >
            <div className="flex items-center gap-3">
              <span className="text-xl">🇺🇸</span>
              <div className="text-left">
                <div className="text-sm font-medium text-gray-900 dark:text-white">English</div>
                <div className="text-xs text-gray-500 dark:text-dark-400">English</div>
              </div>
            </div>
            {currentLanguage === "en" && (
              <Check className="w-4 h-4 text-primary-600 dark:text-primary-400" />
            )}
          </button>

          <button
            onPointerDown={() => setLanguage("es")}
            className={`w-full flex items-center justify-between p-3 rounded-lg border transition-all duration-200 ${
              currentLanguage === "es"
                ? "border-primary-500 bg-primary-50 dark:bg-primary-900/30"
                : "border-gray-200 dark:border-dark-600 hover:border-gray-300 dark:hover:border-dark-500 bg-gray-50 dark:bg-dark-700 hover:bg-gray-100 dark:hover:bg-dark-600"
            }`}
            style={{ touchAction: "manipulation" }}
          >
            <div className="flex items-center gap-3">
              <span className="text-xl">🇪🇸</span>
              <div className="text-left">
                <div className="text-sm font-medium text-gray-900 dark:text-white">Español</div>
                <div className="text-xs text-gray-500 dark:text-dark-400">Spanish</div>
              </div>
            </div>
            {currentLanguage === "es" && (
              <Check className="w-4 h-4 text-primary-600 dark:text-primary-400" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
